const KEY = process.env.REACT_APP_CARTO_KEY;
const suffix = KEY ? `?key=${KEY}` : "";

export const CARTO_LIGHT = `https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png${suffix}`;
export const CARTO_DARK = `https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png${suffix}`;
export const cartoRawTile = (style, zoom, x, y, sub) => `https://${sub}.basemaps.cartocdn.com/${style}/${zoom}/${x}/${y}@2x.png${suffix}`;
